import { SET_LOADING_MANAGER_STATE, LOADING_STATE } from './loading-manager.constants';

export const setLoadingManagerState = (state: LOADING_STATE) => ({
    type: SET_LOADING_MANAGER_STATE,
    payload: state
});
